export default __webpack_public_path__ + "static/media/Macaron-Cake-2.03b4885c.jpg";